import { Box, Text } from '@sendsprint/ui-react';
import React, { ReactNode } from 'react';

interface Props {
  header: string;
  number: string;
  body: string;
  extraDetails?: ReactNode;
}

const VeriffModalItem = ({ body, number, header, extraDetails }: Props) => {
  return (
    <Box className="ss-flex ss-items-center ss-mb-6 ss-bg-neutral-100 ss-p-4 ss-rounded">
      <Text variant="h1" className="ss-text-neutral-20 ss-mr-4">
        {number}
      </Text>
      <Box className="ss-flex-1">
        <Text className="ss-font-semibold">{header}</Text>
        <Text
          variant="paragraphSmall"
          dangerouslySetInnerHTML={{ __html: body }}
          className="ss-text-neutral-40"
        />
        {extraDetails && <Box className="ss-mt-4">{extraDetails}</Box>}
      </Box>
    </Box>
  );
};

export default VeriffModalItem;
